// Mixin global para agregar la clase custom-control-success-switch a todos los b-form-checkbox con switch
export default {
  mounted() {
    // Solo aplica si el componente es b-form-checkbox y tiene la prop switch
    if (
      this.$options &&
      this.$options.name === 'BFormCheckbox' &&
      this.switch
    ) {
      this.$nextTick(() => {
        // Busca el wrapper generado por BootstrapVue
        const el = this.$el.closest('.custom-switch')
        if (el && !el.classList.contains('custom-control-success-switch')) {
          el.classList.add('custom-control-success-switch')
        }
      })
    }
  }
}